export class WorkItemStatusChangeInput{
    public workItemId: number;
    public crmUserId: number;
    public sessionToken: string;
    public updatedByUserId: number;
    public workItemStatus: string;
    
    }